import { Component, OnInit } from '@angular/core';
import { TeamProfile } from '../../../models/team-profile';
import { TeamService } from '../../../services/team.service';
import { UtilsService } from '../../../services/utils.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-team',
  templateUrl: './new-team.component.html',
  styleUrls: ['./new-team.component.scss'],
})
export class NewTeamComponent implements OnInit {
  team: TeamProfile = new TeamProfile();
  selectedAudioFile: File = null;
  uploadingAudio = false;

  constructor(
    private teamService: TeamService,
    private utilsService: UtilsService,
    private router: Router,
  ) {
    this.team.status = 'INACTIVE';
  }

  ngOnInit() {}

  onAudioSelected(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedAudioFile = event.target.files[0];
    }
  }

  uploadAudio() {
    if (!this.selectedAudioFile) {
      this.utilsService.openSnackBar('Please select an audio file first.', '');
      return;
    }
    this.uploadingAudio = true;

    this.teamService.issuePresignedURL(this.selectedAudioFile.type).subscribe(
      (presigned: any) => {
        const { signedRequest, fileName } = presigned;
        this.teamService.uploadToS3(signedRequest, this.selectedAudioFile).subscribe(
          () => {
            const fileInput = {
              path: fileName,
              mimetype: this.selectedAudioFile.type,
              filename: this.selectedAudioFile.name,
              teamProfileId: null,
            };
            this.teamService.createFile(fileInput).subscribe(
              (fileResult: any) => {
                const newFile = fileResult.data['createFile'];
                this.team.audioFileId = newFile.id;
                this.team.audioFile = newFile;
                this.uploadingAudio = false;
                this.utilsService.openSnackBar('Pronunciation audio uploaded successfully!', '');
              },
              (err) => {
                this.uploadingAudio = false;
                this.utilsService.openSnackBar('Audio uploaded to S3, but DB registration failed.', '');
              },
            );
          },
          (err) => {
            this.uploadingAudio = false;
            this.utilsService.openSnackBar('Failed to upload audio to S3.', '');
          },
        );
      },
      (err) => {
        this.uploadingAudio = false;
        this.utilsService.openSnackBar('Failed to get upload URL.', '');
      },
    );
  }

  createTeamMember() {
    const requiredSuccess = this.utilsService.validateRequiredFields(
      this.team.name,
      this.team.designation,
      this.team.location,
      this.team.description,
    );
    if (requiredSuccess) {
      const payload = {
        name: this.team.name,
        designation: this.team.designation,
        location: this.team.location,
        description: this.team.description,
        status: this.team.status || 'INACTIVE',
        dzongkhaName: this.team.dzongkhaName || null,
        audioFileId: this.team.audioFileId || null,
      };
      this.teamService.createTeamProfile(payload).subscribe(
        (response: any) => {
          if (response.errors && response.errors.length > 0) {
            const errors = response.errors.map((err) => err.message);
            this.utilsService.openSnackBar(errors.join(', '), '');
          } else {
            this.utilsService.openSnackBar('Team Member Created!', '');
            const id = response.data['createTeamProfile'].id;
            this.router.navigate(['/teams/view', id]);
          }
        },
        (error) => {
          this.utilsService.openSnackBar('Unable to create team member.', '');
          console.log('Error creating team member:', error);
        },
      );
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/teams/new-team/new-team.component.ts